import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityPaisesDocumentoLoadFailure,
  entityPaisesDocumentoLoadSuccess,
  entityPaisesDocumentoLoadRequest
} from './paises-documento.actions';

import { PaisDocumentoService } from '@rpe/registro-personas-empresas-lib';

@Injectable()
export class PaisesDocumentoEffects {
  // load
  loadRequestPaisesDocumento = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPaisesDocumentoLoadRequest),
      mergeMap(() =>
        this.paisesDocumentoService.getPaisDocumento().pipe(
          map((items) => entityPaisesDocumentoLoadSuccess({ items })),
          catchError((error) => of(entityPaisesDocumentoLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private paisesDocumentoService: PaisDocumentoService
  ) {
    this.paisesDocumentoService.url = environment.apiUrl;
  }
}
